import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {AppMemoryService} from '../../core/app-memory.service';

@Component({
  selector: 'app-auth-header',
  templateUrl: './auth-header.component.html',
  styleUrls: ['./auth-header.component.less']
})
export class AuthHeaderComponent implements OnInit {

  public availableCountries = [];

  constructor(public appMemory: AppMemoryService) {
  }

  ngOnInit() {
      Object.keys(environment.availableCountries).forEach(country => {
          if(country !== environment.country) {
              this.availableCountries.push({
                  country: country,
                  url: environment.availableCountries[country]
              })
          }
      });
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/auth/auth-header/auth-header.component.ts